import React, { useEffect, useState } from "react";
import { Paper, InputBase, IconButton, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./SearchBar.scss";

export default function SearchBar(props) {
  const [searchVal, setSearchVal] = useState("");

  useEffect(() =>{
    setSearchVal(props?.searchValue || "");
  }, [props?.searchValue])

  const onSearch = (e) => {
    setSearchVal(e.target.value)
    props?.onSearch(e.target.value);
  };

  
  return (
    <Box className="customSearchBar">
      <Paper className="customPaperRoot">
        <IconButton className="iconButton" type="button" aria-label="search">
          <SearchIcon />
        </IconButton>
        <InputBase
          onChange={(e) => {
            onSearch(e);
          }}
          className="inputBase"
          placeholder={props?.placeholder || "Search"}
          value={searchVal || ""}
        inputProps={{ "aria-label": "search google maps" }}
        />
      </Paper>
    </Box>
  );
}